module.exports = __webpack_public_path__ + "static/media/1stSlide.71183218.mp3";